export const FETCH_EXPENSES_HEADS_REQUEST = 'FETCH_EXPENSES_HEADS_REQUEST';
export const FETCH_EXPENSES_HEADS_SUCCESS = 'FETCH_EXPENSES_HEADS_SUCCESS';
export const FETCH_EXPENSES_HEADS_FAILURE = 'FETCH_EXPENSES_HEADS_FAILURE';

export const SAVE_EXPENSES_HEAD_REQUEST = 'SAVE_EXPENSES_HEAD_REQUEST';
export const SAVE_EXPENSES_HEAD_SUCCESS = 'SAVE_EXPENSES_HEAD_SUCCESS';
export const SAVE_EXPENSES_HEAD_FAILURE = 'SAVE_EXPENSES_HEAD_FAILURE';

export const CHANGE_EXPENSES_HEAD_STATUS_REQUEST = 'CHANGE_EXPENSES_HEAD_STATUS_REQUEST';
export const CHANGE_EXPENSES_HEAD_STATUS_SUCCESS = 'CHANGE_EXPENSES_HEAD_STATUS_SUCCESS';
export const CHANGE_EXPENSES_HEAD_STATUS_FAILURE = 'CHANGE_EXPENSES_HEAD_STATUS_FAILURE';


// Subhead Actions
export const FETCH_EXPENSES_SUBHEADS_REQUEST = 'FETCH_EXPENSES_SUBHEADS_REQUEST';
export const FETCH_EXPENSES_SUBHEADS_SUCCESS = 'FETCH_EXPENSES_SUBHEADS_SUCCESS';
export const FETCH_EXPENSES_SUBHEADS_FAILURE = 'FETCH_EXPENSES_SUBHEADS_FAILURE';

export const SAVE_EXPENSES_SUBHEAD_REQUEST = 'SAVE_EXPENSES_SUBHEAD_REQUEST';
export const SAVE_EXPENSES_SUBHEAD_SUCCESS = 'SAVE_EXPENSES_SUBHEAD_SUCCESS';
export const SAVE_EXPENSES_SUBHEAD_FAILURE = 'SAVE_EXPENSES_SUBHEAD_FAILURE';

export const CHANGE_EXPENSES_SUBHEAD_STATUS_REQUEST = 'CHANGE_EXPENSES_SUBHEAD_STATUS_REQUEST';
export const CHANGE_EXPENSES_SUBHEAD_STATUS_SUCCESS = 'CHANGE_EXPENSES_SUBHEAD_STATUS_SUCCESS';
export const CHANGE_EXPENSES_SUBHEAD_STATUS_FAILURE = 'CHANGE_EXPENSES_SUBHEAD_STATUS_FAILURE';

export const FETCH_EXPENSES_MAPPED_HEADS_REQUEST = 'FETCH_EXPENSES_MAPPED_HEADS_REQUEST';
export const FETCH_EXPENSES_MAPPED_HEADS_SUCCESS = 'FETCH_EXPENSES_MAPPED_HEADS_SUCCESS';
export const FETCH_EXPENSES_MAPPED_HEADS_FAILURE = 'FETCH_EXPENSES_MAPPED_HEADS_FAILURE';

// mapping heads
export const FETCH_MAPPED_HEADS_REQUEST = 'FETCH_MAPPED_HEADS_REQUEST';
export const FETCH_MAPPED_HEADS_SUCCESS = 'FETCH_MAPPED_HEADS_SUCCESS';
export const FETCH_MAPPED_HEADS_FAILURE = 'FETCH_MAPPED_HEADS_FAILURE';

export const SAVE_MAPPED_HEAD_REQUEST = 'SAVE_MAPPED_HEAD_REQUEST';
export const SAVE_MAPPED_HEAD_SUCCESS = 'SAVE_MAPPED_HEAD_SUCCESS';
export const SAVE_MAPPED_HEAD_FAILURE = 'SAVE_MAPPED_HEAD_FAILURE';

export const CHANGE_MAPPED_HEAD_STATUS_REQUEST = 'CHANGE_MAPPED_HEAD_STATUS_REQUEST';
export const CHANGE_MAPPED_HEAD_STATUS_SUCCESS = 'CHANGE_MAPPED_HEAD_STATUS_SUCCESS';
export const CHANGE_MAPPED_HEAD_STATUS_FAILURE = 'CHANGE_MAPPED_HEAD_STATUS_FAILURE';

export const FETCH_EXPENSE_ENTRY_REQUEST = 'FETCH_EXPENSE_ENTRY_REQUEST';
export const FETCH_EXPENSE_ENTRY_SUCCESS = 'FETCH_EXPENSE_ENTRY_SUCCESS';
export const FETCH_EXPENSE_ENTRY_FAILURE = 'FETCH_EXPENSE_ENTRY_FAILURE';

export const SAVE_EXPENSE_ENTRY_REQUEST = 'SAVE_EXPENSE_ENTRY_REQUEST';
export const SAVE_EXPENSE_ENTRY_SUCCESS = 'SAVE_EXPENSE_ENTRY_SUCCESS';
export const SAVE_EXPENSE_ENTRY_FAILURE = 'SAVE_EXPENSE_ENTRY_FAILURE';

export const FETCH_EXPENSES_ENTRY_MAPPED_HEADS_REQUEST = 'FETCH_EXPENSES_ENTRY_MAPPED_HEADS_REQUEST';
export const FETCH_EXPENSES_ENTRY_MAPPED_HEADS_SUCCESS = 'FETCH_EXPENSES_ENTRY_MAPPED_HEADS_SUCCESS';
export const FETCH_EXPENSES_ENTRY_MAPPED_HEADS_FAILURE = 'FETCH_EXPENSES_ENTRY_MAPPED_HEADS_FAILURE';

export const CHANGE_EXPENSES_ENTRY_STATUS_REQUEST = 'CHANGE_EXPENSES_ENTRY_STATUS_REQUEST';
export const CHANGE_EXPENSES_ENTRY_STATUS_SUCCESS = 'CHANGE_EXPENSES_ENTRY_STATUS_SUCCESS';
export const CHANGE_EXPENSES_ENTRY_STATUS_FAILURE = 'CHANGE_EXPENSES_ENTRY_STATUS_FAILURE';

export const FETCH_EXPENSE_ENTRY_REPORT_REQUEST = 'FETCH_EXPENSE_ENTRY_REPORT_REQUEST';
export const FETCH_EXPENSE_ENTRY_REPORT_SUCCESS = 'FETCH_EXPENSE_ENTRY_REPORT_SUCCESS';
export const FETCH_EXPENSE_ENTRY_REPORT_FAILURE = 'FETCH_EXPENSE_ENTRY_REPORT_FAILURE';

export const FETCH_EXPENSES_APPROVAL_LISTS_REQUEST = 'FETCH_EXPENSES_APPROVAL_LISTS_REQUEST';
export const FETCH_EXPENSES_APPROVAL_LISTS_SUCCESS = 'FETCH_EXPENSES_APPROVAL_LISTS_SUCCESS';
export const FETCH_EXPENSES_APPROVAL_LISTS_FAILURE = 'FETCH_EXPENSES_APPROVAL_LISTS_FAILURE';

export const SAVE_EXPENSES_APPROVAL_LISTS_REQUEST = 'SAVE_EXPENSES_APPROVAL_LISTS_REQUEST';
export const SAVE_EXPENSES_APPROVAL_LISTS_SUCCESS = 'SAVE_EXPENSES_APPROVAL_LISTS_SUCCESS';
export const SAVE_EXPENSES_APPROVAL_LISTS_FAILURE = 'SAVE_EXPENSES_APPROVAL_LISTS_FAILURE';

export const FETCH_EXPENSES_HEADS_GRID_REQUEST = 'FETCH_EXPENSES_HEADS_GRID_REQUEST';
export const FETCH_EXPENSES_HEADS_GRID_SUCCESS = 'FETCH_EXPENSES_HEADS_GRID_SUCCESS';
export const FETCH_EXPENSES_HEADS_GRID_FAILURE = 'FETCH_EXPENSES_HEADS_GRID_FAILURE';